import { adminHttpClient } from '../commons/adminHttpClient'

export type SaveExpenseRequest = {
  expenseId?: string
  planPeriodId: string
  familyMemberId?: string
  expenseTypeId: number
  name?: string
  multipleDates: MultipleDatesRequest[]
  serviceProvider: string
  description: string
  attachments: AttachmentProps[]
  workPhone?: string
}

type MultipleDatesRequest = {
  requestedAmount: number
  purchasedDate: Date
}

type AttachmentProps = {
  id?: string
  filename: string
  title: string
  reuseInOtherExpenses: boolean
}

const saveReimbursementRequest = (values: SaveExpenseRequest): Promise<string[]> => {
  return adminHttpClient.post('/Expenses', values)
}

export default saveReimbursementRequest
